import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  signal,
} from '@angular/core';

import { PublicShopMultimediaUploadComponent } from '../public-shop-multimedia-upload/public-shop-multimedia-upload.component';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Guid, Nillable, valueOrDefault } from '@web/utils';
import { MultimediaType } from '../../../shared/enums/multimedia-type';

@Component({
  selector: 'app-public-shop-multimedia-upload-control',
  imports: [PublicShopMultimediaUploadComponent],
  templateUrl: './public-shop-multimedia-upload-control.component.html',
  styleUrl: './public-shop-multimedia-upload-control.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PublicShopMultimediaUploadControlComponent),
      multi: true,
    },
  ],
})
export class PublicShopMultimediaUploadControlComponent implements ControlValueAccessor {
  public readonly maxFileSize = input<number>(5 * 1000 * 1000);
  public readonly maxNumberOfFiles = input<number>(5);
  public readonly multi = input<boolean>(false);

  protected readonly disabled = signal(false);
  protected readonly selectedFileIds = signal<Guid[]>([]);
  /* prettier-ignore */
  protected readonly allowedMimeTypes = 'image/png, image/apng, image/vnd.mozilla.apng, image/jpeg, image/gif, image/webp, image/svg+xml, image/svg';
  protected readonly allowedMultimediaTypes: MultimediaType[] = [
    MultimediaType.Image,
  ];

  private onChange!: (value: Nillable<Guid[]>) => void;
  private onTouched!: () => void;

  public writeValue(value: Nillable<Guid[]>): void {
    this.selectedFileIds.set(valueOrDefault(value, []));
  }

  public registerOnChange(fn: (value: Nillable<Guid[]>) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  protected handleSelectFilesEvent(ids: Guid[]): void {
    this.onChange(ids);
    this.onTouched();
  }
}
